import * as React from "react";
import { cls } from "@utdanningsdirektoratet/utils/cls";
import { create } from "zustand";
import styles from "./Progress.module.less";

const store = create<number>(() => -1);

export const show = (): void => {
  store.setState((prevState) => Math.max(prevState + 1, 1));
};

export const hide = (completely?: boolean): void => {
  if (completely) {
    store.setState(0);
  } else {
    store.setState((prevState) => (prevState > 0 ? prevState - 1 : prevState));
  }
};

const Progress: React.FC = () => {
  const progressState = store((state) => state);

  const progressClassName = cls({
    [styles.progress]: true,
  });
  const loaderClassName = cls({
    [styles.progressLoader]: true,
    [styles.progressLoaderShow]: progressState > 0,
    [styles.progressLoaderFinishing]: progressState === 0,
  });
  return (
    <div className={progressClassName}>
      <div className={loaderClassName} onAnimationEnd={() => store.setState((prevState) => prevState - 1)} />
    </div>
  );
};

export default Progress;
